import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, LineChart, TrendingUp, Briefcase, Award } from 'lucide-react';
import { services } from '../utils/mockData';

const Services = () => {
  const iconMap = {
    LineChart, TrendingUp, Briefcase, Award
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-semibold text-gray-900 mb-6 leading-tight">
              Services
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Comprehensive marketing and consulting solutions designed for international business growth.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="space-y-16 max-w-5xl">
            {services.map((service) => {
              const Icon = iconMap[service.icon];
              return (
                <div key={service.id} className="border-t border-gray-200 pt-12 first:border-t-0 first:pt-0">
                  <div className="flex items-start space-x-6">
                    <div className="w-14 h-14 bg-blue-900 flex items-center justify-center flex-shrink-0">
                      <Icon className="text-white" size={28} />
                    </div>
                    <div className="flex-1">
                      <h2 className="text-3xl font-semibold text-gray-900 mb-4">
                        {service.title}
                      </h2>
                      <p className="text-lg text-gray-600 leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Service Approach */}
      <section className="py-24 bg-gray-50 border-y border-gray-200">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <h2 className="text-3xl font-semibold text-gray-900 mb-6">
              Service Delivery
            </h2>
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                All services are customized based on the specific requirements of each client engagement. Our process includes initial assessment, strategy development, implementation, and ongoing performance evaluation.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                We maintain regular communication throughout the project lifecycle and provide detailed reporting on progress and outcomes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* International Clients */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <h2 className="text-3xl font-semibold text-gray-900 mb-6">
              International Business Focus
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              ETAN LLC has particular experience working with clients operating in the European Union and international markets. Our services are structured to accommodate:
            </p>
            <ul className="space-y-3 text-lg text-gray-700">
              <li className="flex items-start">
                <span className="mr-3 text-blue-900">•</span>
                <span>Cross-border business operations and market entry strategies</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-blue-900">•</span>
                <span>Multi-jurisdictional regulatory considerations</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-blue-900">•</span>
                <span>International marketing and positioning requirements</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-blue-900">•</span>
                <span>Adaptation to diverse market environments and business cultures</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-blue-900">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <h2 className="text-4xl font-semibold text-white mb-6">
              Discuss Your Requirements
            </h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              Contact us to arrange a consultation and learn how our services can support your business objectives.
            </p>
            <Link to="/contact">
              <Button 
                className="bg-white hover:bg-gray-100 text-blue-900 px-8 h-12 rounded-sm font-medium transition-colors duration-200"
              >
                Request Consultation
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;